import React from "react";

const WhyBecomeSeller = () => {
  return (
    <section className='why-seller py-80'>
      <div className='container'>
        <div className='section-heading text-center mx-auto'>
          <h5 className=''>Why Become a Fun Card Vendor?</h5>
          <span className='text-gray-600'>
            Free and Effective Way to Get Your Business More Exposure
          </span>
        </div>
        <div className='row gy-4 justify-content-center'>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-gift' />
              </span>
              <h6 className='my-28'>Coupon Simplicity / Complexity</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Zero Upfront Listing Cost, User-Friendly Dashboard, Trackable Coupon Redemptions, and Customers can spend with you right away.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-credit-card' />
              </span>
              <h6 className='my-28'>Tourist Friendly</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Fun Card also functions as a Tourist GuideBook that you're apart of. When vacationers look where to save, you come up.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-chats' />
              </span>
              <h6 className='my-28'>Full Control</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                You choose what you want to offer, and we build for you. Zero pressure to offer more savings than what you can afford.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBecomeSeller;
